import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function XLogo20231Icon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M18.0925 2.5166H21.3119L14.2431 10.5652L22.5017 21.4834H16.0208L10.9467 14.8485L5.13767 21.4834H1.91822L9.40694 12.8748L1.49829 2.5166H8.14016L12.7244 8.57757L18.0925 2.5166ZM16.9657 19.5937H18.7503L7.20232 4.33629H5.28465L16.9657 19.5937Z"
				fill="currentColor"
			/>
		</svg>
	);
}

XLogo20231Icon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default XLogo20231Icon;
